import Person from './Person';
import { makeObservable, observable } from 'mobx';
import { persist } from 'mobx-persist';

export default class User extends Person {
  admin;
  archived;
  experience;
  type;

  constructor({ archived, admin, type, experience, ...props } = {}) {
    super({ ...props });

    persist('admin')(this, 'admin');
    persist('archived')(this, 'archived');
    persist('experience')(this, 'experience');
    persist('type')(this, 'type');

    this.archived = archived;
    this.admin = admin;
    this.experience = experience;
    this.type = type;

    makeObservable(this, {
      admin: observable,
      archived: observable,
      experience: observable,
      type: observable
    });
  }
}
